var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Renders a "glass pane" behind a component that blocks defaulting/propagation
 * of click and focus events. Used in situations where doing so in handlers on
 * the children themselves may be inconvenient / impossible.
 */
export var EventShield = function (props) { return (_jsx("div", __assign({ onClick: function (e) {
        e.preventDefault();
        e.stopPropagation();
    }, onFocus: function (e) {
        e.preventDefault();
        e.stopPropagation();
    } }, { children: props.children }))); };
